import { render } from "./P031.vue?vue&type=template&id=646518a9&scoped=true"
import script from "./P031.vue?vue&type=script&lang=js"
export * from "./P031.vue?vue&type=script&lang=js"

import "./P031.vue?vue&type=style&index=0&id=646518a9&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646518a9"]])

export default __exports__